export default {
      id: "photo-upload-usage",
      viewBox: "0 0 42 43",
      url: __webpack_public_path__ + "sprite.svg#photo-upload",
      toString: function () {
        return this.url;
      }
    }